function retrieveShowTravelTime(companyId) {
    return window.tenantAxios.get(`/company/${companyId}/show-travel-time`);
}

function updateShowTravelTime(companyId, showTravelTime) {
    return window.tenantAxios.patch(`/company/${companyId}/show-travel-time`, showTravelTime);
}

export default {
    retrieveShowTravelTime,
    updateShowTravelTime,
};
